import React, { useEffect, useState } from 'react';
import DefaultLayout from './DefaultLayout';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCars } from '../redux/actions/carsActions';
import { Col, Row, DatePicker, Space } from 'antd';
import Spinner from '../components/Spinner';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

function Home() {
  const { cars } = useSelector(state => state.cars);
  const { loading } = useSelector(state => state.alertsReducer);
  const [totalCars, setTotalcars] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    // Fetch cars data from the server
    dispatch(getAllCars());
  }, [dispatch]);

  useEffect(() => {
    // Update the available cars whenever the car data changes
    setTotalcars(cars);
  }, [cars]);

  console.log("cars (type):", typeof cars, Array.isArray(cars), cars);


  function setFilter(values) {
    if (!values || values.length === 0) return;

    const selectedFrom = dayjs(values[0]);
    const selectedTo = dayjs(values[1]);

    const temp = [];

    for (const car of cars) {
      let isAvailable = true;

      // Log the car's current bookings
      console.log(`Checking availability for car: ${car._id}`);
      for (const booking of car.bookedTimeSlots) {
        const bookingFrom = dayjs(booking.from);
        const bookingTo = dayjs(booking.to);
        const now = dayjs();

        console.log(`Checking booking: ${bookingFrom} to ${bookingTo}`);

        // If the booking is already over, skip it
        if (bookingTo.isBefore(now)) continue;

        // Check if the selected range overlaps with this booking
        const overlaps =
          selectedFrom.isBetween(bookingFrom, bookingTo, null, '[)') ||
          selectedTo.isBetween(bookingFrom, bookingTo, null, '(]') ||
          bookingFrom.isBetween(selectedFrom, selectedTo, null, '[)') ||
          bookingTo.isBetween(selectedFrom, selectedTo, null, '(]') ||
          selectedFrom.isSame(bookingFrom) || selectedTo.isSame(bookingTo);

        console.log(`Overlaps: ${overlaps}`);

        if (overlaps) {
          isAvailable = false;
          break;
        }
      }

      console.log(`Car available: ${isAvailable}`);

      if (isAvailable) temp.push(car);
    }

    setTotalcars(temp);

    // Provide feedback if no cars are available
    if (temp.length === 0) {
      console.log("No cars available for the selected time range.");
      // You could add a message here to notify users that no cars are available
    }
  }





  return (
    <DefaultLayout>
      <Row className='mt-3' justify='center'>
        <Col lg={20} sm={24} className='d-flex justify-content-left'>
          <Space direction="vertical" size={12}>
            <RangePicker
              showTime={{ format: 'HH:mm' }}
              format="YYYY-MM-DD HH:mm"
              onChange={(values) => {
                console.log("Selected Range:", values);  // Log the values before passing to setFilter
                setFilter(values);
              }}
              style={{ width: '100%' }}
            />
          </Space>
        </Col>
      </Row>
      {loading === true && (<Spinner />)}
      <Row justify='center' gutter={16}>
        {(totalCars && Array.isArray(totalCars) && totalCars.length > 0) ? totalCars.map(car => (
          <Col lg={6} md={8} sm={24} xs={24} key={car._id}>
            <div className='car p-2 bs1'>
              <img src={car.image} className='carimg' alt='carimg' />
              <div className='car-content d-flex align-items-center justify-content-between'>
                <div className='text-left pl-2'>
                  <p>{car.make}</p>
                  <p className=''>Rate Per 25 Miles:  ${car.rentPerHour}/-</p>
                </div>
                <div>
                  <button className='btn1 mr-2'>
                    <Link to={`/booking/${car._id}`}>BOOK NOW!</Link>
                  </button>
                </div>
              </div>
            </div>
          </Col>
        )) : (!loading && (
          <Col span={24} className="text-center mt-4">
            <p>No cars available. Please try a different time range.</p>
          </Col>
        ))}

      </Row>
    </DefaultLayout>
  );
}

export default Home;
